var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInfoOutlined(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 18,
    viewBox: "0 0 19 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.9375 8.4375L8.96825 8.4225C9.06442 8.37445 9.17235 8.35497 9.27925 8.36637C9.38615 8.37776 9.48755 8.41955 9.57143 8.48678C9.65532 8.55402 9.71818 8.64388 9.75257 8.74574C9.78697 8.8476 9.79145 8.95717 9.7655 9.0615L9.2345 11.1885C9.20836 11.2929 9.2127 11.4026 9.24702 11.5045C9.28133 11.6065 9.34418 11.6965 9.4281 11.7639C9.51202 11.8312 9.6135 11.8731 9.7205 11.8845C9.82749 11.8959 9.93551 11.8764 10.0317 11.8282L10.0625 11.8125M16.25 9C16.25 9.88642 16.0754 10.7642 15.7362 11.5831C15.397 12.4021 14.8998 13.1462 14.273 13.773C13.6462 14.3998 12.9021 14.897 12.0831 15.2362C11.2642 15.5754 10.3864 15.75 9.5 15.75C8.61358 15.75 7.73583 15.5754 6.91689 15.2362C6.09794 14.897 5.35382 14.3998 4.72703 13.773C4.10023 13.1462 3.60303 12.4021 3.26381 11.5831C2.92459 10.7642 2.75 9.88642 2.75 9C2.75 7.20979 3.46116 5.4929 4.72703 4.22703C5.9929 2.96116 7.70979 2.25 9.5 2.25C11.2902 2.25 13.0071 2.96116 14.273 4.22703C15.5388 5.4929 16.25 7.20979 16.25 9ZM9.5 6.1875H9.506V6.1935H9.5V6.1875Z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoOutlined);
export default __webpack_public_path__ + "static/media/info-outlined.ca18a95e4b8db7357fba6293d81b6a5b.svg";
export { ForwardRef as ReactComponent };